module.exports = __webpack_public_path__ + "img/about-paolo.png?85e68c146f57ac89c897c04a2cb24642";